import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { observer, Observer } from 'mobx-react';
import { styled } from '@mui/material/styles';


import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { DatePickerWithBtn } from './DatePicker'
import { useHistory } from 'react-router-dom';
import { getEventByName } from './utils';
import { FilledBtn, StyledIcon, Title, VisitTitle } from './styles';
import { RecordsProps } from './Records';
import { useHorsesStore } from '../../../stores/horses';
import { Box, Container } from '@mui/material';

//Contact Label
type TextFieldProps = {
    label: string;
    content?: string;
    color?: string;
}
const Text: FunctionComponent<TextFieldProps> = (props) => {
    return <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" marginTop={"20px"} marginBottom={"20px"}>
        <Label color={props.color}>{props.label}:</Label>
        {props.content ? <Content color={props.color}>{props.content}</Content> : null}
    </Stack>
}

const Label = styled(Title)`
    min-width:120px;
    margin:0;
    font-size: 18px;
    color:${props => props.color};
`
const Content = styled(Title)`
    margin:0;
    font-size: 16px;
    font-weight:500;
    color:${props => props.color};
`


//Contact box area
interface ContactsProps extends RecordsProps {
    contacts?: {
        name: string,
        email: string,
        phone: string,
        address: string,
        profile_id: string,
        _ID?: string,
        event_type: number | string
    }
}
const Contacts: FunctionComponent<ContactsProps> = (props) => {
    const route = useHistory()
    const store = useHorsesStore()
    const onEdit = () => {
        route.push('/contact', {
            title: props.title,
            profile_id: props.profileId,
            event_type: Number(getEventByName({ name: props.title })),
            ...props.contacts
        })
    }
    const color = useMemo(() => {
        return props.color == '#f4f4f4' ? '#000' : '#fff'
    }, [])

    const expandColor = useMemo(() => {
        return props.color == '#f4f4f4' ? '#000' : 'white'
    }, [])

    return <div style={{ backgroundColor: props.color, width: '100%' }}><ResContactsWrapper color={props.color}>
        <Stack direction="column" justifyContent="center" alignItems="flex-start" sx={{
            width: '100%',
        }}>
            <Accordion defaultExpanded={false} square disableGutters={true} sx={{
                backgroundColor: 'transparent !important',
                boxShadow: 'none !important',
                border: '0 !important',
                position: 'initial !important',
                width: '100%'
            }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon fontSize="large" sx={{ color: expandColor }} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Stack sx={{
                        flexDirection: {
                            xs: 'column',
                            sm: 'row'
                        }
                    }} justifyContent="flex-start" alignItems="center" width={'100%'}>

                        <VisitTitle color={color}>{props.config?.contactTitle != undefined ? props.config.contactTitle : `${props.title} Contact Details:`}</VisitTitle>
                        {store.isEditingMode == true && <OutlinedShortBtn variant="outlined" startIcon={<StyledIcon />} onClick={onEdit} sx={{
                            marginLeft: {
                                xs: '0',
                                sm: 'auto'
                            },
                            marginRight: {
                                xs: '0',
                                sm: '24px'
                            },
                            padding: 0
                        }}>
                            EDIT DETAILS
                        </OutlinedShortBtn>}



                    </Stack>
                </AccordionSummary>

                <AccordionDetails>
                    <Grid container spacing={2} justifyContent="flex-start" marginTop={'20px'}>
                        <Grid item xs={12} sm={6}>
                            <Text color={color} label='Name' content={props.contacts?.name} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Text color={color} label='Email' content={props.contacts?.email} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Text color={color} label='Phone' content={props.contacts?.phone} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Text color={color} label='Address' content={props.contacts?.address ? props.contacts?.address.replace(/[';']/g, " ") : ''} />
                        </Grid>
                        <Grid item xs={12}>
                            {props.contacts && store.isEditingMode == true && <DatePickerWithBtn onChange={(val) => {
                                console.log(val)
                            }}
                                name={props.contacts.name}
                                eventId={Number(getEventByName({ name: props.title }))}
                                email={props.contacts.email}
                                profileId={props.contacts.profile_id}
                                address={props.contacts.address}
                            />}
                        </Grid>

                    </Grid>
                </AccordionDetails>

            </Accordion>
        </Stack>

    </ResContactsWrapper></div>
}

const StyledContactsWrapper = styled(Container)`
    display:flex;
    flex:1;
    background-color:${props => props.color};
    padding:80px;
    justify-content: center;
    align-items:flex-start;
    flex-basis:50%;
`
const ResContactsWrapper = styled(StyledContactsWrapper)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        padding: '20px',
    },
}));

const OutlinedShortBtn = styled(FilledBtn)`
    font-size:10px  !important;
    background-color: #fff !important;
    color: black !important;
    border-color:#3333  !important;
    width:185px !important;
    font-family:inherit !important;
    padding:0  !important;
    width: 140px !important;
    height: 35px !important;
`
export default Contacts
